import {
	createRouter,
	createWebHashHistory
} from 'vue-router'
import HomePage from '../screens/HomePage.vue'

const routes = [{
		path: '/',
		name: 'home',
		component: HomePage
	},
	{
		path: '/about',
		name: 'about',
		component: () => import( /* webpackChunkName: "about" */ '../about-us/AboutUsPage.vue')
	},
	{
		path: '/TeamSpotlightPage',
		name: 'TeamSpotlightPage',
		component: () => import( /* webpackChunkName: "about" */ '../team-spotlight/TeamSpotlightPage.vue')
	},
	{
		path: '/NewsUpdatesPage',
		name: 'NewsUpdatesPage',
		component: () => import( /* webpackChunkName: "about" */ '../news-updates/NewsUpdatesPage')
	},
	{
		path: '/PartyBuildingPage',
		name: 'PartyBuildingPage',
		component: () => import( /* webpackChunkName: "about" */ '../party-building/PartyBuildingPage.vue')
	},
	{
		path: '/JoinUsPage',
		name: 'JoinUsPage',
		component: () => import( /* webpackChunkName: "about" */ '../join-us/JoinUsPage.vue')
	},
	{
		path: '/ContactUsPage',
		name: 'ContactUsPage',
		component: () => import( /* webpackChunkName: "about" */ '../contact-us/ContactUsPage.vue')
	},
	{
		path: '/newsdetail',
		name: 'newsdetail',
		component: () => import( /* webpackChunkName: "about" */ '../newsdetail/newsdetail.vue')
	}
	// {
	// 	path: '/api-test',
	// 	name: 'ApiTest',
	// 	component: () => import( /* webpackChunkName: "api-test" */ '../test-navigation/ApiTestPage.vue')
	// }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

export default router